import {
  format,
  parse,
  parseISO,
  isWeekend,
  isAfter,
  isBefore,
  isEqual,
  isValid,
  addDays,
  isExists,
  addMonths,
  addYears,
  isSameDay,
} from 'date-fns';
import { isEmptyString } from '.';

// 주민등록상 생일을 현재 날짜와 비교하여 나이계산 (만)
export const getAge = (rsdn1, rsdn2) => {
  var ssnNo = rsdn1;
  var ssnNo2 = rsdn2;

  var curDateObj = new Date(); // 날짜 Object 생성
  var tmpSSN = ssnNo; // 주민번호
  var curDate = ''; // 현재일자
  var tmpAge = 0; // 임시나이
  var y = curDateObj.getFullYear(); // 현재년도
  var m = curDateObj.getMonth() + 1; // 현재월
  if (m < 10) m = '0' + m; // 현재 월이 10보다 작을경우 '0' 문자 합한다
  var d = curDateObj.getDate(); // 현재일
  if (d < 10) d = '0' + d; // 현재 일이 10보다 작을경우 '0' 문자 합한다
  curDate = y + m + d;

  var genType = ssnNo2.substring(0, 1); // 주민번호 성별구분 문자 추출
  if (
    genType === '1' ||
    genType === '2' ||
    genType === '5' ||
    genType === '6'
  ) {
    tmpAge = y - (1900 + parseInt(tmpSSN.substring(0, 2))); // 1, 2 일경우
  } else {
    tmpAge = y - (2000 + parseInt(tmpSSN.substring(0, 2))); // 그 외의 경우
  }

  var tmpBirthday = tmpSSN.substring(2, 6); // 주민번호 4자리 생일문자 추출
  if (curDate.substring(4) < tmpBirthday) {
    tmpAge -= 1;
  }

  return tmpAge;
};

/**
 * format에 형식으로 날짜 반환
 * @param {string}} dateString : date string
 * @param {string} formatString : format
 * @returns {string} date
 */
export const getDateByformat = (
  dateString,
  formatString = 'yyyy.MM.dd HH:mm',
) => {
  try {
    return format(parseISO(dateString.replace(/\//g, '')), formatString);
  } catch {
    return dateString ?? '';
  }
};

/**
 * 평일 검증 함수
 * @param {date}} date
 * @returns {boolen} 평일 체크
 */
export const isWeekday = date => {
  return !isWeekend(date);
};

/**
 * 날짜 허용 범위 검증 함수
 * @param {date} date
 * @param {number} startAddDate : 날짜 허용 범위 시작 일자 현재일자와 차이
 * @param {number} endAddDate : 날짜 허용 허용 범위 끝 일자 현재일자와 차이
 * @param {number} DateType : 현재 일자와 차이 단위 y: 년, m: 월, d: 일
 * @param {date} compareDate : 비교 날짜
 * @returns {boolen} 허용 범위 날짜 체크
 */
export const isAllowbleDateRange = (
  date,
  startAddDate,
  endAddDate = 0,
  compareDate = new Date(),
  // DateType = 'd', // 추후...
) => {
  return (
    isAfter(date, addDays(compareDate, startAddDate)) &&
    isBefore(date, addDays(compareDate, endAddDate))
  );
};

/**
 * 이후 날짜 검증
 * @param {date} date
 * @param {date} compareDate : 비교 날짜
 * @param {boolen} isIncludedEqual : 동일 날짜 포함 여부
 * @returns {boolen} 이후 날짜 체크
 */
export const isAfterDay = (
  date,
  compareDate = new Date(),
  isIncludedEqual = true,
) => {
  return isIncludedEqual
    ? isAfter(date, compareDate) || isEqual(date, compareDate)
    : isAfter(date, compareDate);
};

/**
 * 이전 날짜 검증
 * @param {date} date
 * @param {date} compareDate : 비교 날짜
 * @param {boolen} isIncludedEqual : 동일 날짜 포함 여부
 * @returns {boolen} 이전 날짜 체크
 */
export const isBeforeDay = (
  date,
  compareDate = new Date(),
  isIncludedEqual = true,
) => {
  return isIncludedEqual
    ? isBefore(date, compareDate) || isEqual(date, compareDate)
    : isBefore(date, compareDate);
};

/**
 * 오늘 날짜 to string
 * @param {string} dateFormat 날짜 포맷
 * @returns
 */
export const getToday = (dateFormat = 'yyyy.MM.dd') => {
  return format(new Date(), dateFormat);
};

/**
 * 날짜 데이터 object형태로
 * @param {string} date 날짜
 * @returns
 */
export const getDateSplit = date => {
  const dateString = date.replace(/[^0-9]/g, '');
  return {
    year: Number(dateString.substr(0, 4)),
    month: Number(dateString.substr(4, 2)) - 1,
    day: Number(dateString.substr(6, 2)),
    hour: Number(dateString.substr(8, 2)) || '',
    minute: Number(dateString.substr(10, 2)) || '',
    second: Number(dateString.substr(12, 2)) || '',
  };
};

/**
 * 날짜 데이터 검증
 * @param {string} date
 * @returns
 */
export const isExistsDate = date => {
  const { year, month, day } = getDateSplit(date);
  return isExists(year, month, day);
};

/**
 * 두 Date 객체의 날짜가 같은지 확인하는 함수
 * @param {Date} date1 날짜가 같은지 확인할 Date 객체1
 * @param {Date} date2 날짜가 같은지 확인할 Date 객체2
 * @return {boolean} 두 날짜가 같은지 여부
 * @author Robin
 */
export const checkIsSameDay = (date1, date2) => {
  return isSameDay(date1, date2);
};

/**
 * 날짜 계산
 * @param {string} date 날짜
 * @param {string} type 년/월/일
 * @param {number} amount 증감
 * @param {string} dateFormat 날짜 포맷
 * @returns
 */
export const addDates = (date, type, amount, dateFormat = 'yyyy.MM.dd') => {
  if (isExistsDate(date)) {
    const { year, month, day } = getDateSplit(date);
    if (type.includes('year')) {
      return format(addYears(new Date(year, month, day), amount), dateFormat);
    } else if (type.includes('month')) {
      return format(addMonths(new Date(year, month, day), amount), dateFormat);
    } else if (type.includes('week')) {
      return format(
        addDays(new Date(year, month, day), amount * 7),
        dateFormat,
      );
    } else if (type.includes('day')) {
      return format(addDays(new Date(year, month, day), amount), dateFormat);
    } else {
      return date;
    }
  } else {
    return getToday();
  }
};

/**
 * 날짜 String을 Date 객체로 변환하는 함수
 * @param {string} dateString 날짜 String
 * @param {string} currentFormat 현재 dateString의 Date Format
 * @return {Date}
 */
export const toDate = (dateString, currentFormat = 'yyyyMMdd') => {
  const date = parse(dateString, currentFormat, new Date());
  const isValidDate = isValid(date);
  if (isValidDate) return date;
  // Asis의 toDate() 함수
  else {
    if (isExistsDate(dateString)) {
      const { year, month, day } = getDateSplit(dateString);
      return new Date(year, month, day);
    } else {
      return new Date();
    }
  }
};

/**
 * 특정 날짜 Date를 dateFormat 형식으로 변환하는 함수
 * @param {Date | number} date Date 객체
 * @param {string} dateFormat 변환할 날짜 형식 [Default: yyyyMMdd]
 * @param {object?} options 옵션들
 * @return {string} dateFormat 형식으로 변환된 날짜 String
 */
export const formatDate = (date, dateFormat = 'yyyyMMdd', options) => {
  return format(date, dateFormat, options);
};

/**
 * Milli Second 형태의 숫자를 시간 형식으로 변경해주는 함수
 * @param {number} milliSecondTime 밀리 세컨드(ms) 형태의 Number
 * @param {boolean} isHour 시간 단위도 표시 할 지 여부 (기본은 분 단위로 표시)
 * @returns {string} displayTime
 */
export const toDisplayTime = (milliSecondTime, isHour = false) => {
  const signValue = milliSecondTime >= 0 ? '' : '-';
  let targetTime = Math.abs(milliSecondTime);

  const HOUR = 1000 * 60 * 60;
  const MINUTE = 1000 * 60;
  const SECOND = 1000;

  const formatTimeText = timeText => `0${timeText}`.slice(-2);
  const getTimeText = timeValue => {
    const time = Math.floor(targetTime / timeValue);
    targetTime = targetTime - time * timeValue;

    return formatTimeText(time);
  };

  const displayTexts = [];
  const displayTimes = [MINUTE, SECOND];
  if (isHour) displayTimes.unshift(HOUR);

  while (displayTimes.length > 0) {
    const timeText = getTimeText(displayTimes.shift());
    displayTexts.push(timeText);
  }

  const displayTime = displayTexts.join(':');

  return `${signValue}${displayTime}`;
};

/**
 * 'yyyyMMdd' format의 날짜 string을 Date 객체로 변환해주는 함수
 * @param {string} dateText 'yyyyMMdd' format의 날짜 string
 * @return {object} 입력된 날짜 string의 파싱된 Date 객체
 * @author Robin
 */
export const parseDateString = (dateText = '') => {
  const dateInfo = getDateSplit(dateText);

  const { year, month, day } = dateInfo;
  const monthValue = `0${month + 1}`.slice(-2);
  const dateValue = `0${day}`.slice(-2);
  const dateString = `${year}-${monthValue}-${dateValue}`;
  return new Date(dateString);
};

/**
 * 입력된 오늘 날짜의 '월'이 입력된 두 날짜의 사이에 있는지 알아보는 함수
 * @param {string | Date} start dateFormat('yyyyMMdd') 형태 | 혹은 Date 객체인 시작 비교 날짜
 * @param {string | Date} end dateFormat('yyyyMMdd') 형태 | 혹은 Date 객체인 종료 비교 날짜
 * @param {number} startFrom 몇 개월 전 부터 시킬지에 대한 숫자 값
 * @param {number} endTo 몇 개월 후까지 시킬지에 대한 월 숫자 값
 * @param {string} dateFormat start, end 값의 날짜 형식 (예] 'yyyyMMdd')
 * @return {boolean} 오늘 날짜가 입력된 두 날짜 사이에 있는 '월'인지 여부
 * @author Robin
 */
export const isTodayMonthBetween = (
  start,
  end,
  startFrom = 0,
  endTo = 0,
  dateFormat = 'yyyyMMdd',
) => {
  const startDate =
    start instanceof Date ? start : parse(start, dateFormat, new Date());
  const endDate =
    end instanceof Date ? end : parse(end, dateFormat, new Date());

  const todayDate = new Date();
  const startCompareDate = addMonths(startDate, startFrom);
  const endCompareDate = addMonths(endDate, endTo);

  // 시작 되었으면서, 끝나지 않았으면 사이에 있는 날짜로 간주
  const isStarted = isBefore(startCompareDate, todayDate);
  const isNotEnded = isAfter(endCompareDate, todayDate);
  const isBetween = isStarted && isNotEnded;

  return isBetween;
};

/**
 * timestamps로 년월일시 텍스트를 구하는 함수
 * @param {number} timestamps
 * @return {string} 년월일시 텍스트
 * @author Asis
 */
export const convertTimeText = timestamps => {
  let result = '';
  if (timestamps !== '') {
    const { year, month, day, hour, minute } = $utils.getDateSplit(timestamps);
    result += `${year}년`;
    result += ` ${month + 1}월`;
    result += ` ${day}일`;
    result += ` ${hour > 12 ? '오후' : '오전'}`;
    result += ` ${hour > 12 ? hour - 12 : hour}시`;
    result += ` ${minute ? minute : '0'}분`;
  }

  return result;
};

/**
 * 날짜 String을 year, month, day 로 잘라서 Object로 리턴하는 함수
 * @param {string} dateString dateFormat 형태의 날짜 String
 * @param {string} dateFormat 변환한 날짜 형식
 * @return {object} 날짜 year, month, day 가 포함된 Obejct
 * @author Robin
 */
export const sliceDateString = (dateString, dateFormat = 'yyyyMMdd') => {
  const yearLength = dateFormat.replace(/[^y]/g, '').length,
    monthLength = dateFormat.replace(/[^mM]/g, '').length,
    dateLength = dateFormat.replace(/[^d]/g, '').length;

  const yearEndIndex = yearLength;
  const monthEndIndex = yearLength + monthLength;
  const dayEndIndex = yearLength + monthLength + dateLength;

  const year = dateString.slice(0, yearEndIndex);
  const month = dateString.slice(yearEndIndex, monthEndIndex);
  const day = dateString.slice(monthEndIndex, dayEndIndex);

  return { year, month, day };
};

/**
 * 날짜 형태 Text를 Date Format 에 맞게 변환하는 함수
 * @param {string} dateString 날짜 String
 * @param {string} dateFormat 날짜 형식 String
 * @return {string} 변환된 날짜 String
 */
export const replaceDateLetters = (dateString, dateFormat = 'yyyyMMdd') => {
  let dateText = dateFormat;
  const { year, month, day } = sliceDateString(dateString, dateFormat);

  // y가 연속되는 경우: 년
  dateText = dateText.replace(/y+/gi, year);

  // m이 연속되는 경우: 월
  dateText = dateText.replace(/m+/gi, month);

  // d가 연속되는 경우: 일
  dateText = dateText.replace(/d+/gi, day);

  // 채워지지 않은 데이터 정리
  // 1. 마지막이 숫자가 아닌 문자면 제거
  dateText = dateText.replace(/\D+$/, '');

  return dateText;
};

/**
 * 날짜 String을 다른 형식의 날짜 String 으로 변환하는 함수
 * @param {string} dateString 날짜 String
 * @param {string?} dateFormat 변환할 날짜 Format
 * @param {string?} currentFormat 현재 dateString의 Date Format
 * @return {string} 변환된 날짜 String
 */
export const convertDateString = (
  dateString,
  dateFormat = 'yyyy.MM.dd',
  currentFormat = 'yyyyMMdd',
) => {
  if (isEmptyString(dateString)) return dateString;

  const date = toDate(dateString, currentFormat);
  const convertedDateString = format(date, dateFormat);
  return convertedDateString;
};

/**
 * 날짜 형식의 String에 점을 붙이는 함수
 * @param {string} dateString 날짜 형식의 String ('yyyyMMdd' / 'yyMMdd')
 * @return {string} 점(.)을 붙인 dateString
 * @author Robin
 */
export const addDotDate = (dateString = '') => {
  // dateString에 점(.)이 포함 된 상태라면 제거하고 추가
  const dateLength = removeDotDate(dateString).length;

  //  dateLength가 8일 때 - yyyy.MM.dd 로 리턴
  if (dateLength === 8) {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    return `${year}.${month}.${day}`;
  }

  // dateLength가 6일 때 - yy.MM.dd 로 리턴
  else {
    const year = dateString.slice(0, 2);
    const month = dateString.slice(2, 4);
    const day = dateString.slice(4, 6);
    return `${year}.${month}.${day}`;
  }
};

/**
 * 날짜 형식의 String에 점(.)을 없애는 함수
 * @param {string} dateString 날짜 형식의 String ('yyyyMMdd' / 'yyMMdd')
 * @return {string} 점(.)을 없앤 dateString
 * @author Robin
 */
export const removeDotDate = (dateString = '') => {
  return dateString.replace(/\./g, '');
};

/**
 * Date String을 Date로 변경 가능하면 Date Text로 리턴하고
 * Date로 변경 불가능한 String일 경우 String 그대로 리턴하는 함수
 * @param {string} dateString 날짜 형태의 String
 * @param {string?} currentFormat 현재 날짜의 형식
 * @param {string?} format 변경할 날짜의 형식
 * @return {string} 변경된 날짜 Text
 * @author Robin
 */
export const parseTextDate = (
  dateString,
  currentFormat = 'yyyyMMdd',
  dateFormat = 'yyyy-MM-dd',
) => {
  const date = parse(dateString, currentFormat, new Date());
  const isValidDate = isValid(date);

  // 날짜 형식이 아니면 문자 그대로 리턴
  if (!isValidDate) return dateString;

  // 날짜 형식이면 주어진 format 형태로 변경하여 리턴
  const dateText = formatDate(date, dateFormat);

  return dateText;
};

/**
 * 해당 Date 객체가 비교할 Date 객체 이전인지 확인하는 함수
 * @param {Date} date 해당 날짜 Date 객체
 * @param {Date} compareDate 해당 날짜와 비교할 Date 객체
 * @param {boolean} isIncludeSame 같은 값도 포함(이상/미만)해서 판단할 지 여부
 * @return {boolean} 해당 Date 객체가 비교할 Date 객체 이전인지 여부
 * @author Robin
 */
export const checkDateBefore = (date, compareDate, isIncludeSame = false) => {
  const isDateObject = date instanceof Date && compareDate instanceof Date;
  if (!isDateObject) {
    console.warn('checkDateBefore() - 파라미터가 Date 객체가 아닙니다.');
    return false;
  }

  const targetTimestamps = date.getTime();
  const compareTimestamps = compareDate.getTime();
  const isDateBefore = isIncludeSame
    ? targetTimestamps <= compareTimestamps
    : targetTimestamps < compareTimestamps;
  return isDateBefore;
};

/**
 * 해당 Date 객체가 비교할 Date 객체 이후인지 확인하는 함수
 * @param {Date} date 해당 날짜 Date 객체
 * @param {Date} compareDate 해당 날짜와 비교할 Date 객체
 * @param {boolean} isIncludeSame 같은 값도 포함(이상/미만)해서 판단할 지 여부
 * @return {boolean} 해당 Date 객체가 비교할 Date 객체 이후인지 여부
 * @author Robin
 */
export const checkDateAfter = (date, compareDate, isIncludeSame = false) => {
  const isDateObject = date instanceof Date && compareDate instanceof Date;
  if (!isDateObject) {
    console.warn('checkDateAfter() - 파라미터가 Date 객체가 아닙니다.');
    return false;
  }

  const targetTimestamps = date.getTime();
  const compareTimestamps = compareDate.getTime();
  const isDateAfter = isIncludeSame
    ? targetTimestamps >= compareTimestamps
    : targetTimestamps > compareTimestamps;
  return isDateAfter;
};

/**
 * 특정 Date 객체가 두 Date 객체의 사이에 있는지 판별하는 함수
 * @param {Date} targetDate 판별할 대상 날짜 Date 객체
 * @param {Date} startDate 시작 비교 날짜 Date 객체
 * @param {Date} endDate 종료 비교 날짜 Date 객체
 * @return {boolean} 특정 Date 객체가 두 Date 객체의 사이에 있는지 여부
 * @author Robin
 */
export const checkDateBetween = (targetDate, startDate, endDate) => {
  const isDateObject =
    targetDate instanceof Date &&
    startDate instanceof Date &&
    endDate instanceof Date;
  if (!isDateObject) {
    console.warn('checkDateBetween() - 파라미터가 Date 객체가 아닙니다.');
    return false;
  }

  // 시작 되었으면서, 끝나지 않았으면 사이에 있는 날짜로 간주
  const isStarted = checkDateAfter(targetDate, startDate, true);
  const isNotEnded = checkDateBefore(targetDate, endDate, true);
  const isBetween = isStarted && isNotEnded;
  return isBetween;
};

/**
 * 특정 날짜 형식으로 되어있는 날짜 Text에서 특정 값(날짜 형식의 문자)을 추출하는 함수
 * @param {string} dateString 값을 추출할 날짜 Text
 * @param {string} dateFormat 날짜 형식 Text
 * @param {string} formatLetter 날짜 형식의 문자 (y / M / d / H / m / s)
 * @return {string}
 * @author Robin
 */
export const getDateFormatValue = (dateString, dateFormat, formatLetter) => {
  const formatRegex = new RegExp(`${formatLetter}+`, 'g');
  const format = dateFormat.match(formatRegex)?.[0];
  format;

  if (!format) return '';

  const startIndex = dateFormat.indexOf(format);
  const endIndex = startIndex + format.length;
  const targetText = dateString.slice(startIndex, endIndex);

  return targetText;
};

/**
 * 특정 날짜의 정보를 Date 객체로 변형하는 함수
 * @param {object} 특정 날짜의 정보 객체
 * @return {Date} Date로 파싱한 날짜 정보
 * @author Robin
 */
export const convertToDate = ({ year, month, date, hour, minute, second }) => {
  const yearText = `${year}`,
    monthText = `0${month}`.slice(-2),
    dateText = date ? `0${date}`.slice(-2) : '01',
    hourText = `0${hour}`.slice(-2),
    minuteText = `0${minute}`.slice(-2),
    secondText = second ? `0${second}`.slice(-2) : '00';

  let dateString = `${yearText}-${monthText}-${dateText}`;
  if (hour && minute)
    dateString = `${dateString} ${hourText}:${minuteText}:${secondText}`;

  return new Date(dateString);
};

/**
 * date-fns의 parseDate()의 Mock 함수 [라이브러리 없는 환경에서 사용을 위해 만듬]
 * @param {string} dateString new Date()로 객체를 만들 수 있는 날짜 String
 * @param {string} dateFormat 날짜 형식
 * @return {Date | null} dateString을 dateFormat 형식으로 변형한 String
 * @author Robin
 */
export const parseDate = (dateString, dateFormat = '') => {
  if (isEmptyString(dateString)) return null;

  try {
    // dateFormat 변형 형식
    // yyyy: 년도 / MM: 월 / dd: 일 / HH: 시간 / mm: 분 / ss: 초
    const year = getDateFormatValue(dateString, dateFormat, 'y');
    const month = getDateFormatValue(dateString, dateFormat, 'M');
    const date = getDateFormatValue(dateString, dateFormat, 'd');
    const hour = getDateFormatValue(dateString, dateFormat, 'H');
    const minute = getDateFormatValue(dateString, dateFormat, 'm');
    const second = getDateFormatValue(dateString, dateFormat, 's');
    const dateObj = convertToDate({
      year,
      month,
      date,
      hour,
      minute,
      second,
    });

    return dateObj;
  } catch (error) {
    console.log('parseDate() - error', error);
    return null;
  }
};

/**
 * 두 Date 객체의 Year 값 차이를 구하는 함수
 * @param {Date} dateLeft
 * @param {Date} dateRight
 * @return {number} 두 Date 객체의 Year 차이
 * @author Robin
 */
export const distanceYear = (dateLeft, dateRight) => {
  const isDateObject = dateLeft instanceof Date && dateRight instanceof Date;
  if (!isDateObject) {
    console.warn('distanceYear() - 파라미터가 Date 객체가 아닙니다.');
    return 0;
  }

  const dateLeftYear = dateLeft.getFullYear();
  const dateRightYear = dateRight.getFullYear();
  return dateLeftYear - dateRightYear;
};

/**
 * 두 Date 객체의 Month 값 차이를 구하는 함수
 * @param {Date} dateLeft
 * @param {Date} dateRight
 * @return {number} 두 Date 객체의 Month 차이
 * @author Robin
 */
export const distanceMonth = (dateLeft, dateRight) => {
  const isDateObject = dateLeft instanceof Date && dateRight instanceof Date;
  if (!isDateObject) {
    console.warn('distanceMonth() - 파라미터가 Date 객체가 아닙니다.');
    return 0;
  }

  const dateLeftMonth = dateLeft.getMonth();
  const dateRightMonth = dateRight.getMonth();
  const yearDistance = distanceYear(dateLeft, dateRight) * 12;
  const dateDistanceFlag = dateLeft.getDate() >= dateRight.getDate() ? 0 : -1;
  const monthDistance =
    yearDistance + dateLeftMonth - dateRightMonth + dateDistanceFlag;
  return monthDistance;
};

/**
 * 두 Date 객체의 Timestamp 값 차이를 구하는 함수
 * @param {Date} dateLeft
 * @param {Date} dateRight
 * @return {number} 두 날짜의 차이의 timestamp 값
 * @author Robin
 */
export const distanceDate = (dateLeft, dateRight) => {
  const isDateObject = dateLeft instanceof Date && dateRight instanceof Date;
  if (!isDateObject) {
    console.warn('distanceDate() - 파라미터가 Date 객체가 아닙니다.');
    return 0;
  }

  const dateLeftTimestamp = dateLeft.getTime();
  const dateRightTimestamp = dateRight.getTime();
  return dateLeftTimestamp - dateRightTimestamp;
};
